/* Copyright 2013 - 2024 Waiterio LLC */
import { useQueryErrorResetBoundary } from '@tanstack/react-query'

export default useQueryErrorResetBoundary
